import api from '../../../services/Api';
import { IAuditoriaLancamentoManualResultado } from '../interfaces/IAuditoriaLancamentoManual';

export const AuditoriaLancamentoManualService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaLancamentoManualResultado> {
    const response = await api.get<IAuditoriaLancamentoManualResultado>('auditoria-lancamento-manual/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        totalLancamentosAnalisados: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoContabil: '',
        lancamentosManuais: [],
      }
    );
  },
};
